export default __webpack_public_path__ + "1e03b8935bb1e545f0e93eb592806c7b.png";